import { Box, styled } from '@mui/material'
import { FC } from 'react'
import { Icon } from 'packages/eid-icons'

interface InfoBoxMessageProps {
    message: string
}

const NoDataFoundRoot = styled(Box)(({ theme }) => ({
    border: 'solid 1px #ebebed',
    boxShadow: '0 4px 6px -2px rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    display: 'inline-flex',
    alignItems: 'center',
    height: '4.8rem',
    background: '#fff',
    overflow: 'hidden',
}))

const InfoIcon = styled(Box)(({ theme }) => ({
    background: '#8b909a',
    width: '4.8rem',
    height: '4.8rem',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
        width: '2.4rem !important',
        height: '2.4rem !important',
    },
}))

const InfoMsg = styled(Box)(({ theme }) => ({
    padding: '1.6rem',
    color: '#5d6870',
}))

const InfoBoxMessage: FC<InfoBoxMessageProps> = ({ message }) => {
    return (
        <NoDataFoundRoot>
            <InfoIcon>
                <Icon name="InfoNew" />
            </InfoIcon>
            <InfoMsg>{message}</InfoMsg>
        </NoDataFoundRoot>
    )
}

export default InfoBoxMessage
